import LOGO from '../../assets/images/eprakashak_logo.jpg'

export const LOGO_ICO = LOGO